
import { useState } from "react";
import { Wrapper, StateText, ToggleCircle } from "./ThreeWayToggleStyles";

type TToggleText = {
	turnOnText: string;
	turnOffText: string;
}

type TThreeWayToggleProps = {
	onChange: (v: boolean | undefined) => void;
	toggleInitialState?: number;
	disableMiddlePosition?: boolean;
	toggleTexts?: TToggleText;
}

const ThreeWayToggle = ({ onChange, toggleInitialState = 0, disableMiddlePosition = false, toggleTexts }: TThreeWayToggleProps) => {
	const [toggleState, setToggleState] = useState<number>(toggleInitialState);

	const { turnOnText = "Sí", turnOffText = "No" } = toggleTexts || {};

	const changeValue = () => {
		let stateChange: boolean | undefined = undefined;
		let newState: number = 0;

		switch (toggleState) {
			case 0:
				newState = disableMiddlePosition ? 1 : -1;
				stateChange = disableMiddlePosition ? true : undefined;
				break;
			case 1:
				newState = 0;
				stateChange = false;
				break;
			case -1:
				newState = 1;
				stateChange = true;
				break;
			default:
				break;
		}

		setToggleState(newState);
		onChange(stateChange);
	};

	return (
		<Wrapper toggleState={toggleState} onClick={changeValue}>
			{toggleState === 1 && <StateText toggleState={toggleState}>{turnOnText}</StateText>}
			<ToggleCircle toggleState={toggleState} />
			{toggleState === 0 && <StateText toggleState={toggleState}>{turnOffText}</StateText>}
		</Wrapper>
	);
};

export default ThreeWayToggle;
